var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('mapbox',{attrs:{"map-options":_vm.mapOptions,"geolocate-control":_vm.geolocateControl,"nav-control":_vm.navControl,"access-token":_vm.mapboxToken},on:{"map-init":_vm.mapInitialized}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }